module.exports = __webpack_public_path__ + "img/LoginCard-left.6096f551.png";